import useTenFreeDeliveryProducts from "hook/useTenFreeDeliveryProducts";
import { Link } from "react-router-dom";
import { FaTruck } from "react-icons/fa";
import ProductCard from "components/ProductCard";

const FreeDeliveryProducts = () => {
  const { tenFreeDeliveryProducts } = useTenFreeDeliveryProducts();

  return (
    <section className="sm:mt-10 mt-6 px-4 sm:px-6">
      {tenFreeDeliveryProducts.length > 0 ? (
        <div className="rounded-lg bg-red-50 p-[1px] shadow">
          <div className="rounded-t-lg bg-red-100 p-4 text-[#E60076] sm:p-6">
            <div className="flex justify-between">
              <h3 className="text-lg sm:font-extrabold font-bold sm:text-2xl flex items-center gap-2">
                <FaTruck className="text-[#E60076]" />
                Free Delivery Deals
              </h3>
              <Link
                to="/freeDeliveryProducts"
                className="inline-flex items-center gap-2 rounded-full border border-[#E60076] bg-white/10 sm:px-4 px-3 ms:py-2 py-1 text-xs font-semibold text-[#E60076] backdrop-blur transition hover:bg-white/20 sm:text-sm"
              >
                Explore All
              </Link>
            </div>
            <p className="col-span-2 text-xs text-slate-500 sm:text-base mt-1">
              Save more with zero delivery charges. Limited-time selection!
            </p>
          </div>
          {/* <div className="sm:px-5 px-2"> */}
          <div className="m-4 flex snap-x gap-3 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            {tenFreeDeliveryProducts
              .filter((item) => item.hideStatus === "available")
              .map((item) => (
                <ProductCard
                  key={item.id}
                  item={item}
                  bgClass="bg-white"
                  currencyClass="text-emerald-600"
                />
              ))}
          </div>
          {/* </div> */}
        </div>
      ) : null}
    </section>
  );
};

export default FreeDeliveryProducts;
